<template>
  <div class="jump_wrapper">
    <div class="cmp__wrap">
      <template v-if="nodes && nodes.length">
        <component v-for="(node, index) in nodes" :key="index" :is="node.tag" :config="node"></component>
      </template>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import utils from "@/utils";

export default {
  name: "Jump",
  components: {
    XImage: () => import('@/components/XImage')
  },
  data() {
    return {
      nodes: []
    };
  },
  created() {
    if (utils.isMobile()) {
      this.loadSource();
    } else {
      this.$router.replace('/')
    }
  },
  methods: {
    loadSource() {
      let t = this.$route.query.t
      api.ajax4Page('sms').then(res => {
        let { nodes } = res;
        // 页面信息处理       
        if (Array.isArray(nodes) && nodes.length) {
          const target = res.nodes.find(o => o.tag === 'XImage' && o.action.type === 'jump_app' && o.action.data.path.indexOf(t) != -1);
          this.nodes = res.nodes;
          target && this.$nextTick(() => {
            this.initAction(target);
          });
        } else {
          this.$message({ message: "页面配置错误", iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    initAction(cfgNode = {}) {
      let { type, data: { path } } = cfgNode.action;
      if (type === 'jump_app' && path) {
        location.href = path;
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>